import consolePolyfill from "./consolePolyfill";
import initEs from "./es/es";


// Avoid console errors in browsers that lack a console
consolePolyfill();

/*
 * Declare or extend global es API var containing.
 */
const es = window["es"] || {};
initEs(es);

/*
 * Load up the messages
 * See also: http://codingwithcoffee.com/?p=272
 * alert($j.i18n.prop('msg_hello'));
 * alert($j.i18n.prop('msg_complex', ['John']));
 */
$.i18n.properties({
    name: 'iSmart_Messages',
    language: es.lang,
    mode: 'map'
});